function productionsFilter(productions) {
  const filteredProductions = [];

  productions.forEach((production) => {
    // if (!production.isVisible) {
    //   console.log('skipping non-visible production:', production);
    //   return;
    // }

    const filteredPerformances = production.performances
      // .filter((perf) => {
      //   if (!perf.isPerformanceVisible) {
      //     console.log('removing non visible performance:', perf);
      //     return false;
      //   }

      //   // Weed out performances that don't have a valid displayDate
      //   if (!perf.displayDate && perf.displayDate === 'null') {
      //     console.log('removing invalid displayDate perf:', perf);
      //     return false;
      //   }

      //   return true;
      // })
      .map(perf =>
        // Prep performances with any additional properties
         Object.assign({}, perf, {
           iso8601Date: new Date(perf.iso8601DateString),
         }));

    if (filteredPerformances.length > 0) {
      filteredProductions.push(Object.assign({}, production, {
        performances: filteredPerformances,
      }));
    }
  });

  return filteredProductions;
}

export default productionsFilter;



// WEBPACK FOOTER //
// ./V7/events/listing/api/productionsFilter.js